var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDongLuong(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5048 4.86827C8.75951 4.97658 9.00614 5.09941 9.2442 5.23613C9.42845 5.24988 9.68472 5.23843 9.68466 4.99213C9.68466 4.99217 9.67411 0.243196 9.67411 0.243196C9.67378 0.0875523 9.53018 -0.0278033 9.37905 0.00587549C7.14043 0.504715 5.35291 2.20835 4.72363 4.40534C5.99468 4.20337 7.32411 4.36252 8.5048 4.86827Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7959 5.35768C-1.15618 5.31082 -2.18407 15.6434 4.51627 17.0716C4.63209 17.0977 4.74264 17.0098 4.74234 16.8901L4.7322 12.3322C4.73196 12.2298 4.64932 12.1469 4.54745 12.1469H3.92073C3.71913 12.1469 3.59736 11.9227 3.70641 11.7522C6.48035 7.68175 5.13367 7.68295 7.90815 11.7522C8.01723 11.9226 7.89546 12.1469 7.69386 12.1469H6.98597C6.88376 12.1469 6.80099 12.2303 6.80122 12.333L6.81137 16.9041C6.81163 17.0213 6.91874 17.1101 7.03283 17.0858C13.8048 15.7158 12.7923 5.29786 5.7959 5.35768Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9994 6.05255C16.955 3.11365 14.9067 0.663383 12.1673 0.0210837C12.0154 -0.014531 11.8702 0.102226 11.8705 0.259038L11.881 4.99332C11.8813 5.12754 11.9897 5.23622 12.1232 5.23622H12.7945C12.9861 5.23622 13.1019 5.4493 12.9982 5.61129L11.7065 7.63075C12.5291 8.96167 12.877 10.5725 12.6854 12.1296C15.2124 11.2923 17.042 8.87376 16.9994 6.05255Z",
    fill: "#F2F2F2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDongLuong);
export default __webpack_public_path__ + "static/media/icon-dong-luong.a3e1f778.svg";
export { ForwardRef as ReactComponent };